import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { CAMPAIGNS } from '../constants'

const updateCampaignEnable = async (id: number) => {
  await fetchAPI({
    method: 'put',
    path: `/campaigns/${id}/enable`,
  })
}

export const useUpdateCampaignEnable = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(updateCampaignEnable, {
    onSuccess: async () => {
      await queryClient.refetchQueries([CAMPAIGNS])

      toast({
        description: t('views.admin.campaigns.services.update_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
